import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from '../styles.module.scss';
import { getInstructionsComponentByPlatform } from './instructions/utils';
export var Instructions = function (_a) {
    var selectedPlatform = _a.selectedPlatform;
    var InstructionsComponent = getInstructionsComponentByPlatform(selectedPlatform);
    return (_jsxs("div", { className: styles.instructions, children: [_jsx("h4", { className: styles['instructions-title'], children: "Instructions" }), _jsx(InstructionsComponent, {})] }));
};
